import { apiService } from './apiService';

export const publicApi = {
  // Homepage and basic site info
  getHomepage: async () => {
    return apiService.get('/public');
  },

  getSiteSettings: async () => {
    return apiService.get('/public/site-settings');
  },

  // Page management
  getPage: async (slug) => {
    return apiService.get(`/public/pages/${slug}`);
  },

  getPagesByTemplate: async (template) => {
    return apiService.get(`/public/template/${template}`);
  },

  // Navigation
  getNavigation: async (location) => {
    return apiService.get(`/public/navigation/${location}`);
  },

  // Search
  searchPages: async (query, page = 1) => {
    return apiService.get('/public/search', { 
      params: { q: query, page } 
    });
  },

  // Events
  getEvents: async (params = {}) => {
    return apiService.get('/public/events', { params });
  },

  getEvent: async (identifier) => {
    return apiService.get(`/public/events/${identifier}`);
  },

  getUpcomingEvents: async (limit = 5) => {
    return apiService.get('/public/upcoming-events', { params: { limit } });
  },

  getPastEvents: async (params = {}) => {
    return apiService.get('/public/past-events', { params });
  },

  getEventsByCategory: async (category) => {
    return apiService.get(`/public/events/category/${category}`);
  },

  getEventSchedule: async (month, year) => {
    return apiService.get('/public/event-schedule', { 
      params: { month, year } 
    });
  },

  getFeaturedEvents: async (limit = 3) => {
    return apiService.get('/public/featured-events', { params: { limit } });
  },

  searchEvents: async (query, params = {}) => {
    return apiService.get('/public/events/search', { 
      params: { q: query, ...params } 
    });
  },

  getEventStatistics: async () => {
    return apiService.get('/public/events/statistics');
  },

  // Rules & Documentation
  getRules: async () => {
    return apiService.get('/public/rules');
  },

  getRuleCategories: async () => {
    return apiService.get('/public/rules/categories');
  },

  getRulesByCategory: async (categorySlug) => {
    return apiService.get(`/public/rules/category/${categorySlug}`);
  },

  getRule: async (ruleSlug) => {
    return apiService.get(`/public/rules/${ruleSlug}`);
  },

  getRuleByNumber: async (ruleNumber) => {
    return apiService.get(`/public/rules/number/${ruleNumber}`);
  },

  searchRules: async (query, params = {}) => {
    return apiService.get('/public/rules/search', {
      params: { q: query, ...params }
    });
  },

  getBaseballBasics: async () => {
    return apiService.get('/public/baseball-basics');
  },

  getPopularRuleTags: async () => {
    return apiService.get('/public/rules/popular-tags');
  },

  getRuleStatistics: async () => {
    return apiService.get('/public/rules/statistics');
  },

  // Gallery & Media Management
  getGallery: async () => {
    return apiService.get('/public/media/gallery');
  },

  getMediaCategories: async (type = null) => {
    const params = type ? { type } : {};
    return apiService.get('/public/media/categories', { params });
  },

  getMediaByCategory: async (categorySlug, params = {}) => {
    return apiService.get(`/public/media/category/${categorySlug}`, { params });
  },

  getMediaItem: async (id) => {
    return apiService.get(`/public/media/${id}`);
  },

  downloadMedia: async (id) => {
    return apiService.get(`/public/media/${id}/download`, {
      responseType: 'blob'
    });
  },

  getDocuments: async (params = {}) => {
    return apiService.get('/public/media/documents', { params });
  },

  searchMedia: async (query, params = {}) => {
    return apiService.get('/public/media/search', {
      params: { q: query, ...params }
    });
  },

  getMediaByTags: async (tags, params = {}) => {
    return apiService.get('/public/media/tags', {
      params: { tags, ...params }
    });
  },

  getPopularMediaTags: async () => {
    return apiService.get('/public/media/popular-tags');
  },

  getMediaStatistics: async () => {
    return apiService.get('/public/media/statistics');
  },

  // Contact & Communication
  getContactInfo: async () => {
    return apiService.get('/public/contact');
  },

  submitContactForm: async (formData) => {
    return apiService.post('/public/contact/submit', formData);
  },

  getContactStatistics: async () => {
    return apiService.get('/public/contact/statistics');
  },

  getContactFAQ: async () => {
    return apiService.get('/public/contact/faq');
  },

  verifyContactSubmission: async (contactId, token) => {
    return apiService.get(`/public/contact/verify/${contactId}/${token}`);
  },

  // Sitemap
  getSitemap: async () => {
    return apiService.get('/public/sitemap');
  },

  // Certificate Verification
  getCertificateVerificationInfo: async () => {
    return apiService.get('/public/certificates');
  },

  verifyCertificate: async (verificationData) => {
    return apiService.post('/public/certificates/verify', verificationData);
  },

  verifyCertificateByQR: async (qrData) => {
    return apiService.post('/public/certificates/verify-qr', qrData);
  },

  getCertificate: async (certificateNumber) => {
    return apiService.get(`/public/certificates/${certificateNumber}`);
  },

  downloadCertificate: async (certificateId) => {
    return apiService.get(`/public/certificates/${certificateId}/download`, {
      responseType: 'blob'
    });
  },

  generateCertificateQR: async (certificateId) => {
    return apiService.get(`/public/certificates/${certificateId}/qr`, {
      responseType: 'blob'
    });
  },

  getCertificateStatistics: async () => {
    return apiService.get('/public/certificates/statistics');
  },

  searchCertificates: async (searchParams) => {
    return apiService.get('/public/certificates/search', { params: searchParams });
  },

  // Rules & Documentation
  getRules: async () => {
    return apiService.get('/public/rules');
  },

  getRuleCategories: async () => {
    return apiService.get('/public/rules/categories');
  },

  getRulesByCategory: async (categorySlug) => {
    return apiService.get(`/public/rules/category/${categorySlug}`);
  },

  getRule: async (ruleSlug) => {
    return apiService.get(`/public/rules/${ruleSlug}`);
  },

  getRuleByNumber: async (ruleNumber) => {
    return apiService.get(`/public/rules/number/${ruleNumber}`);
  },

  searchRules: async (searchParams) => {
    return apiService.get('/public/rules/search', { params: searchParams });
  },

  getPopularRuleTags: async () => {
    return apiService.get('/public/rules/popular-tags');
  },

  getRuleStatistics: async () => {
    return apiService.get('/public/rules/statistics');
  },

  getBaseballBasics: async () => {
    return apiService.get('/public/rules/basics');
  },

  // Baseball Glossary
  getGlossary: async (params = {}) => {
    return apiService.get('/public/rules/glossary', { params });
  },

  getBaseballTerm: async (termSlug) => {
    return apiService.get(`/public/rules/glossary/${termSlug}`);
  },

  // Educational Guides
  getEducationalGuides: async (params = {}) => {
    return apiService.get('/public/rules/guides', { params });
  },

  getEducationalGuide: async (guideSlug) => {
    return apiService.get(`/public/rules/guides/${guideSlug}`);
  },

  // Content Management System (Public Read)
  getContent: async (params = {}) => {
    return apiService.get('/public/content', { params });
  },

  getContentBySlug: async (slug) => {
    return apiService.get(`/public/content/${slug}`);
  },

  getContentByType: async (typeSlug, params = {}) => {
    return apiService.get(`/public/content/type/${typeSlug}`, { params });
  },

  getFeaturedContent: async (params = {}) => {
    return apiService.get('/public/content/featured', { params });
  },

  getRecentContent: async (params = {}) => {
    return apiService.get('/public/content/recent', { params });
  },

  searchContent: async (searchParams) => {
    return apiService.get('/public/content/search', { params: searchParams });
  },

  getContentSitemap: async () => {
    return apiService.get('/public/content/sitemap');
  },

  // Cache management
  clearCache: async () => {
    return apiService.post('/public/clear-cache');
  },
};